import TipsDialog from './Index.vue'

TipsDialog.install = function(Vue) {
  Vue.component(TipsDialog.name, TipsDialog)
}

export default TipsDialog
